export default __webpack_public_path__ + "static/media/mail.89e40fd0.svg";